import { createSlice } from "@reduxjs/toolkit";

const initialUsersState = {
  usersList: null,
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  userForDetails: undefined,
  userDisabled: null,
  userDisabledLoading: false,
  userKicked: null,
  userKickedLoading: false,
  userShadowbanned: null,
  userShadowbanLoading: false,
  userReenabled: null,
  userReenabledLoading: false,
  userInformation: null,
  userInformationLoading: false,
  error: null,
  userToAdmin: null,
  userToAdminLoading: false,
  userToVerifiedLoading: false,
  userToVerified: null,
};

export const callTypes = {
  list: "list",
  action: "action",
  disabled: "disabled",
  kickout: "kickout",
  shadowban: "shadowban",
  reenable: "reenable",
  information: "information",
  promoteusertoadmin: "promoteusertoadmin",
  promotetouserverified: "promotetouserverified",
};

export const usersSlice = createSlice({
  name: "Users",
  initialState: initialUsersState,
  reducers: {
    catchError: (state, action) => {
      state.error = ` ${action.payload.error?.response?.data.message}`;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        case callTypes.action:
          state.actionsLoading = false;
          break;
        case callTypes.disabled:
          state.userDisabledLoading = false;
          break;
        case callTypes.kickout:
          state.userKickedLoading = false;
          break;
        case callTypes.shadowban:
          state.userShadowbanLoading = false;
          break;
        case callTypes.reenable:
          state.userReenabledLoading = false;
          break;
        case callTypes.information:
          state.userInformationLoading = false;
          break;
        case callTypes.promotetouserverified:
          state.userToVerifiedLoading = false;
          break;
        case callTypes.promoteusertoadmin:
          state.userToAdminLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        case callTypes.action:
          state.actionsLoading = true;
          break;
        case callTypes.disabled:
          state.userDisabledLoading = true;
          break;
        case callTypes.kickout:
          state.userKickedLoading = true;
          break;
        case callTypes.shadowban:
          state.userShadowbanLoading = true;
          break;
        case callTypes.reenable:
          state.userReenabledLoading = true;
          break;
        case callTypes.information:
          state.userInformationLoading = true;
          break;
        case callTypes.promotetouserverified:
          state.userToVerifiedLoading = true;
          break;
        case callTypes.promoteusertoadmin:
          state.userToAdminLoading = true;
          break;
        default:
          break;
      }
    },
    usersFetched: (state, action) => {
      state.listLoading = false;
      state.usersList = action.payload.usersList;
      state.error = null;
    },
    userFetched: (state, action) => {
      state.actionsLoading = false;
      state.userForDetails = action.payload.userForDetails;
      state.error = null;
    },
    userDisabled: (state, action) => {
      state.userDisabledLoading = false;
      state.userDisabled = action.payload.userDisabled;
      state.error = null;
    },
    userKickedOut: (state, action) => {
      state.userKickedLoading = false;
      state.userKicked = action.payload.userKicked;
      state.error = null;
    },
    userToAdmin: (state, action) => {
      state.userToAdminLoading = false;
      state.userToAdmin = action.payload.userToAdmin;
      state.error = null;
    },
    userToVerified: (state, action) => {
      state.userToVerifiedLoading = false;
      state.userToVerified = action.payload.userToVerified;
      state.error = null;
    },
    userShadobanned: (state, action) => {
      state.userShadowbanLoading = false;
      state.userShadowbanned = action.payload.userShadowbanned;
      state.error = null;
    },
    userReenabled: (state, action) => {
      state.userReenabledLoading = false;
      state.userReenabled = action.payload.userReenabled;
      state.error = null;
    },
    userInformationFetched: (state, action) => {
      state.userInformation = action.payload.userInformation;
      state.userInformationLoading = false;
      state.error = null;
    },
  },
});
